import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import LandingAnimation from "./components/LandingAnimation";
import "./App.css";
import Home from "./home";
import RSVP from "./RSVP";
import ExpressionOfInterest from "./ExpressionOfInterest";
import Timeline from "./Timeline";
import Details from "./Details";
import Venue from "./Venue";

function AppContent() {
  const [showLanding, setShowLanding] = useState(false);
  const [pageReady, setPageReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setPageReady(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const hasSeenLanding = sessionStorage.getItem("wedding-landing-seen");
    if (location.pathname === "/" && !hasSeenLanding) {
      setShowLanding(true);
    } else {
      setShowLanding(false);
    }
  }, [location.pathname]);

  const handleAnimationComplete = () => {
    setShowLanding(false);
    sessionStorage.setItem("wedding-landing-seen", "true");
  };

  if (!pageReady) {
    return null;
  }

  return (
    <>
      <div className="App-style">
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/eoi" element={<ExpressionOfInterest />} />
          <Route exact path="/formal-rsvp" element={<RSVP />} />
          <Route exact path="/timeline" element={<Timeline />} />
          <Route exact path="/details" element={<Details />} />
          <Route exact path="/venue" element={<Venue />} />
        </Routes>
      </div>
      {showLanding && <LandingAnimation onComplete={handleAnimationComplete} />}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
